import { motion } from "framer-motion";
import { animationsActives } from "@/lib/motionSafe";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => {
  const on = animationsActives();
  return (
    <motion.div
      className={className}
      initial={on ? { opacity: 0, y } : false}
      whileInView={on ? { opacity: 1, y: 0 } : undefined}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => {
  const on = animationsActives();
  return (
    <span className={`block overflow-hidden pb-[0.16em] -mb-[0.16em] ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={on ? { y: "112%" } : false}
        animate={on ? { y: 0 } : undefined}
        transition={on ? { duration: 1.1, delay, ease: EASE } : undefined}
      >
        {children}
      </motion.span>
    </span>
  );
};
